import { render } from "./GenericModal.vue?vue&type=template&id=24c147dd&scoped=true"
import script from "./GenericModal.vue?vue&type=script&lang=js"
export * from "./GenericModal.vue?vue&type=script&lang=js"

import "./GenericModal.vue?vue&type=style&index=0&id=24c147dd&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24c147dd"]])

export default __exports__